import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material';
import { AppPage } from '@shared';
import OrdersList from '@views/orders/components/OrdersList';
import axios from '@utils/axios-rails';
import CourierList from '@views/couriers/components/CouriersList';

import OrdersListWithFilters from '@views/orders/components/OrdersListWithFilters';
import { pagyShape } from 'utils/shapes';

const propTypes = {
  orders: PropTypes.array,
  team: PropTypes.object.isRequired,
  couriers: PropTypes.array.isRequired,
  couriers_filter: PropTypes.array.isRequired,
  editTeamURL: PropTypes.string.isRequired,
  initialFilters: PropTypes.object,
  pagy: pagyShape.isRequired,
  exportSubmitURL: PropTypes.string.isRequired,
}

const OrdersIndexTeamLeader = ({ team, couriers, ...props }) => {
  const [open, setOpen] = useState(false);
  const openExportModal = () => setOpen(true)
  const closeExportModal = () => setOpen(false)

  return (
    <AppPage fullWidth>
      {/* Polaris' <Layout> with a `secondary` section: a narrow column beside the
          main one, stacked on small screens. */}
      <Grid container spacing={2}>
        {/* Team info section */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <div className="flex justifyBetween">
                <Typography variant="h5">
                  { team.name }
                </Typography>
                <Button variant="contained" href={props.editTeamURL}>
                  Administrar
                </Button>
              </div>
            </CardContent>

            <Divider />

            <CardContent>
              <Typography variant="subtitle2" gutterBottom>
                { I18n.t("activerecord.models.courier.other") }
              </Typography>
              <CourierList
                items={ couriers }
                onClick={() => true}
              />
            </CardContent>
          </Card>
        </Grid>

        {/* Orders Section */}
        <Grid item xs={12} md={8}>
          <OrdersListWithFilters
            orders={ props.orders }
            statuses={ props.statuses }
            couriers={ props.couriers_filter}
            admin= {props.admin}
            teams={ props.teams}
            initialFilters={ props.initialFilters }
            pagy={ props.pagy }
            exportSubmitURL={ props.exportSubmitURL }
          />
        </Grid>
      </Grid>
    </AppPage>
  );
}

OrdersIndexTeamLeader.propTypes = propTypes;

export default OrdersIndexTeamLeader;